export default __webpack_public_path__ + "static/media/IconCancel.cec3ceab.svg";